import React from 'react';

/**
 * Optical Rx mark used wherever the prescription question comes up. Drawn in
 * SVG so it stays sharp and needs no external asset. Deliberately a generic
 * optical/Rx symbol rather than any association's logo, which would imply an
 * endorsement we do not have.
 */
export function RxMark({
  className = 'h-9 w-9'
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 48 48" role="img" aria-label="Prescription" className={className} focusable="false" data-id="element-667" data-mp="2f51fd5qew5z2">
      <circle cx="24" cy="24" r="23" fill="#0E7C86" data-id="element-668" data-mp="219z3m1yvvmec" />
      <circle cx="24" cy="24" r="20" fill="none" stroke="#ffffff" strokeWidth="1.5" opacity="0.65" data-id="element-669" data-mp="263bn5xoph308" />
      <text x="24" y="31" textAnchor="middle" fill="#ffffff" fontFamily="Georgia, Times New Roman, serif" fontSize="22" fontWeight="700" data-id="element-670" data-mp="1reynoqqet20z">
        Rx
      </text>
    </svg>;
}

/**
 * Mobile counterpart to the Rx badge: a full-width strip that sits right under
 * the artwork, where the answer to "can I use my prescription?" has to be
 * visible before anyone scrolls.
 */
export function PrescriptionStrip({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center justify-center gap-3 border-b border-[#0E7C86]/70 bg-[#07242a] px-4 py-3 lg:hidden ${className}`} data-id="element-671" data-mp="39ijglo0y92fq">
      <RxMark className="h-8 w-8 shrink-0" data-id="element-672" data-mp="3jed3a08ducb8" />
      <p className="text-left" data-id="element-673" data-mp="3jcjtwd6dxdzj">
        <span className="block font-display text-lg font-extrabold uppercase leading-none text-[#7fe3ec]" data-id="element-674" data-mp="2vosgt7d0swx7">
          Prescription-ready
        </span>
        <span className="mt-0.5 block text-[13px] font-medium text-steel-200" data-id="element-675" data-mp="2qrii113qr8wp">
          GritVue X1 RX Insert™ sold separately.
        </span>
      </p>
    </div>;
}
interface PrescriptionBadgeProps {
  className?: string;
  /** Compact variant for tight cards. */
  compact?: boolean;
}
export function PrescriptionBadge({
  className = '',
  compact = false
}: PrescriptionBadgeProps) {
  return <div className={`flex items-center gap-3 border border-[#0E7C86]/70 bg-[#07242a] px-4 py-3 ${className}`} data-id="element-676" data-mp="27yy54t4fteej">
      <RxMark className={compact ? 'h-9 w-9 shrink-0' : 'h-11 w-11 shrink-0'} data-id="element-677" data-mp="2xlsitwcoxx3u" />
      <p className="min-w-0" data-id="element-678" data-mp="31nds77q0nt9a">
        <span className={`block font-display font-extrabold uppercase leading-tight tracking-wide text-[#7fe3ec] ${compact ? 'text-base' : 'text-lg sm:text-xl'}`} data-id="element-679" data-mp="36fx31wxbkaae">
          Prescription-ready · RX Insert sold separately
        </span>
        <span className="mt-0.5 block text-[13px] font-medium leading-relaxed text-steel-300" data-id="element-680" data-mp="2equ1iowthe1g">
          The GritVue X1 RX Insert™ sits behind the protective lens. Your local optical shop makes corrective lenses
          for it from your prescription. Prescription lenses are not included.
        </span>
      </p>
    </div>;
}